import React, { useState } from "react";
import { toast } from "react-toastify";

const FindReplace = ({ currentText, onTextChange, textareaRef }) => {
  const [findText, setFindText] = useState("");
  const [replaceText, setReplaceText] = useState("");

  const [caseSensitive, setCaseSensitive] = useState(false);
  const [useRegex, setUseRegex] = useState(false);
  const [wholeWord, setWholeWord] = useState(false);

  const [matches, setMatches] = useState([]);
  const [matchIndex, setMatchIndex] = useState(0);

  /* ---------------- BUILD REGEX ---------------- */
  const buildRegex = () => {
    if (!findText) return null;

    try {
      let pattern = findText;

      if (!useRegex) {
        // escape special chars
        pattern = findText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }

      if (wholeWord) {
        pattern = `\\b${pattern}\\b`;
      }

      const flags = caseSensitive ? "g" : "gi";

      return new RegExp(pattern, flags);
    } catch (err) {
      toast.error("Invalid regex pattern!");
      return null;
    }
  };

  /* ---------------- FIND ---------------- */
  const findMatches = () => {
    const regex = buildRegex();
    if (!regex) return;

    const found = [];
    let match;

    while ((match = regex.exec(currentText)) !== null) {
      found.push(match.index);
    }

    setMatches(found);
    setMatchIndex(0);

    if (found.length === 0) {
      toast.info("No matches found");
      return;
    }

    toast.success(`Found ${found.length} matches`);
    highlightMatch(found[0]);
  };

  /* ---------------- HIGHLIGHT ---------------- */
  const highlightMatch = (index) => {
    if (!textareaRef?.current) return;

    textareaRef.current.focus();
    textareaRef.current.setSelectionRange(
      index,
      index + findText.length
    );
  };

  /* ---------------- NAVIGATION ---------------- */
  // const goToNext = () => {
  //   if (!matches.length) {
  //     toast.info("No matches");
  //     return;
  //   }

  //   const next = (matchIndex + 1) % matches.length;
  //   setMatchIndex(next);
  //   highlightMatch(matches[next]);
  // };

  // const goToPrev = () => {
  //   if (!matches.length) {
  //     toast.info("No matches");
  //     return;
  //   }

  //   const prev = (matchIndex - 1 + matches.length) % matches.length;
  //   setMatchIndex(prev);
  //   highlightMatch(matches[prev]);
  // };

  /* ---------------- REPLACE ONE ---------------- */
  const replaceOne = () => {
    if (!matches.length) {
      toast.info("Nothing to replace");
      return;
    }

    const index = matches[matchIndex];

    const before = currentText.slice(0, index);
    const after = currentText.slice(index + findText.length);

    const updated = before + replaceText + after;

    onTextChange(updated);

    toast.success("Replaced 1 occurrence");

    setTimeout(findMatches, 0);
  };

  /* ---------------- REPLACE ALL ---------------- */
  const replaceAll = () => {
    const regex = buildRegex();
    if (!regex) return;

    const matchCount = (currentText.match(regex) || []).length;

    if (matchCount === 0) {
      toast.info("No matches to replace");
      return;
    }

    const updated = currentText.replace(regex, replaceText);

    onTextChange(updated);

    toast.success(`Replaced ${matchCount} occurrences`);

    setMatches([]);
    setMatchIndex(0);
  };

  /* ---------------- UI ---------------- */
  return (
    <div className="bg-white p-4 rounded-xl shadow-lg space-y-3">
      <h2 className="text-lg font-semibold">Find & Replace</h2>

      {/* FIND */}
      <input
        type="text"
        placeholder="Find..."
        value={findText}
        onChange={(e) => setFindText(e.target.value)}
        className="w-full border px-3 py-2 rounded"
      />

      {/* REPLACE */}
      <input
        type="text"
        placeholder="Replace with..."
        value={replaceText}
        onChange={(e) => setReplaceText(e.target.value)}
        className="w-full border px-3 py-2 rounded"
      />

      {/* OPTIONS */}
      <div className="grid grid-cols-2 gap-2 text-sm">
        <label>
          <input
            type="checkbox"
            checked={caseSensitive}
            onChange={() => setCaseSensitive(!caseSensitive)}
          />{" "}
          Case Sensitive
        </label>

        <label>
          <input
            type="checkbox"
            checked={wholeWord}
            onChange={() => setWholeWord(!wholeWord)}
          />{" "}
          Whole Word
        </label>

        <label>
          <input
            type="checkbox"
            checked={useRegex}
            onChange={() => setUseRegex(!useRegex)}
          />{" "}
          Use Regex
        </label>
      </div>

      {/* ACTIONS */}
      <div className="flex flex-wrap gap-2">
        <button onClick={findMatches} className="btn">
          Find
        </button>
        {/* <button onClick={goToPrev} className="btn">
          Prev
        </button>
        <button onClick={goToNext} className="btn">
          Next
        </button> */}
        <button onClick={replaceOne} className="btn btn-edit">
          Replace
        </button>
        <button onClick={replaceAll} className="btn btn-edit">
          Replace All
        </button>
      </div>

      {/* INFO */}
      <div className="text-sm text-gray-500">
        {matches.length > 0
          ? `Match ${matchIndex + 1} of ${matches.length}`
          : "No matches"}
      </div>
    </div>
  );
};

export default FindReplace;